import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { InvoiceActions } from './actions/invoice.actions';
import { GetSurveysFilters } from '../models/invoice-survey.model';
import type {
  DownloadReportParams,
  DownloadReportType,
  RegenerateParams,
} from '../models/invoice-download.model';

@Injectable({ providedIn: 'root' })
export class InvoiceActionsFacade {
  private readonly _store = inject(Store);

  public searchSurveys(filters: GetSurveysFilters, page: number): void {
    this._store.dispatch(InvoiceActions.searchSurveys({ filters, page }));
  }

  public loadCompanies(): void {
    this._store.dispatch(InvoiceActions.loadCompanies());
  }

  public downloadReport(
    downloadType: DownloadReportType,
    params: DownloadReportParams,
  ): void {
    this._store.dispatch(
      InvoiceActions.downloadReport({ downloadType, params }),
    );
  }

  public regenerateInvoice(params: RegenerateParams): void {
    this._store.dispatch(InvoiceActions.regenerateInvoice({ params }));
  }

  public loadNextPage(): void {
    this._store.dispatch(InvoiceActions.loadNextPage());
  }
}
